export default __webpack_public_path__ + "static/media/7.7a2c11f8.svg";